import { For } from "solid-js";
import {
  clusterEdgeClass,
  clusterEdgePath,
  type EstateRouteFocus,
  edgeClass,
  pageEdgePath,
} from "./estateEdges";
import type { EstateClusterEdge, EstateEdge } from "./estateTypes";

export function EstateClusterEdgeLayer(props: {
  clusterEdges: EstateClusterEdge[];
  focusedCluster: string | null;
  routeFocusActive: boolean;
}) {
  return (
    <g class="signal-cluster-links">
      <For each={props.clusterEdges}>
        {(edge) => (
          <path
            class={clusterEdgeClass(
              edge,
              props.focusedCluster,
              props.routeFocusActive,
            )}
            d={clusterEdgePath(edge)}
            stroke-width={0.42 + Math.min(edge.count, 12) * 0.035}
          >
            <title>{`${edge.from.label} and ${edge.to.label}: ${edge.count} recorded structural ${
              edge.count === 1 ? "link" : "links"
            }`}</title>
          </path>
        )}
      </For>
    </g>
  );
}

export function EstatePageEdgeLayer(props: {
  visibleEdges: EstateEdge[];
  contextPageId: string | null;
  routeFocus: EstateRouteFocus;
}) {
  return (
    <g class="signal-estate-links">
      <For each={props.visibleEdges}>
        {(edge) => (
          <path
            class={edgeClass(edge, props.contextPageId, props.routeFocus)}
            d={pageEdgePath(edge)}
          />
        )}
      </For>
    </g>
  );
}
